import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('token');
    if (!tokenString) return null;
    try {
      const parsed = JSON.parse(tokenString);
      return parsed && parsed.token ? parsed.token : tokenString;
    } catch (e) {
      return tokenString;
    }
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token', userToken.token);
    localStorage.setItem('name', userToken.name);
    localStorage.setItem('email', userToken.email);
    localStorage.setItem('phone', userToken.phone);
    localStorage.setItem('id', userToken.id);
    localStorage.setItem('avatar', userToken.avatar || '');
    localStorage.setItem('banner', userToken.banner || '');
    localStorage.setItem('total', userToken.avatar || userToken.total || ''); // Fallback for backward compatibility
    setToken(userToken.token);
  };

  return {
    setToken: saveToken,
    token
  }
}


